<template>
    <div>
        <div class="mobile-tp-job-wrapper" v-wechat-title="$route.meta.title">
            <div class="filter-search">
                <div class="list-head">
                    <div class="filter-left">Jobs for you</div>
                    <div class="filter-right" @click.stop="() => switchFilter()">
                        <img :src="icons[0].src"/>
                        <span>{{state.label}}</span>
                    </div>
                </div>
            </div>
            <mobile-search :form="query" @search="keywordSearch"/>
            <list-box class="list-body"
                      :empty="loadedJobsLists.length === 0"
                      :loading="loading && loadedJobsLists.length === 0">
                <job-list :loading="loading" :list="loadedJobsLists" @load="load"/>
                <div slot="empty" class="empty">
                    <img :src="icons[1].src" alt="empty"/>
                    <p>No Results Found.</p>
                </div>
            </list-box>
            <mobile-filter ref="mobileFilter" @filter="filter" :state='state'/>
        </div>
        <Modal :page="'Job Board Page'" :saveInfo="saveInfo"/>
    </div>
</template>

<script>
  import mixin from './index.js'
  import JobList from './share/jobList.vue'
  import ListBox from './share/listBox.vue'
  import MobileSearch from './share/search.vue'
  import MobileFilter from './share/filter.vue'
  import Modal from '../discover/modal'
  import mixpanel from '@/utils/mixpanel.js'
  export default {
    name: 'job-board',
    components: {
      MobileSearch,
      MobileFilter,
      JobList,
      ListBox,
      Modal
    },
    mixins: [mixin],
    created() {
        mixpanel.initMixpanel(process.env['VUE_APP_MIX_KEY']);
        mixpanel.track('Job Board Page', {'Outcome': 'Page View'})
    }
  }
</script>

<style lang="scss" scoped>
.mobile-tp-job-wrapper {
	overflow-x: hidden;
	overflow-y: scroll;
	width: 100%;
	height: auto;
	background-color: #fff;
	margin-bottom: 48px;
	padding-top: 50px;
	opacity: 1;
	.board-head {
		font-family: SFProText-Semibold;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
		padding: 11px 51px;
		border-bottom: 1px solid #e7ebf3;
	}
	.filter-search {
		position: fixed;
		top: 0;
		z-index: 1000;
		width: 100%;
		background-color: #fff;
		opacity: 1;
	}
	.list-head {
		background-color: #ffffff;
		display: flex;
		justify-content: space-between;
		padding: 15px;

		.filter-left {
			font-size: 16px;
			font-family: SFProText-Bold;
			line-height: 20px;
			font-weight: bold;
			color: rgb(20, 26, 66);
		}
            .filter-right {
                font-family: SFProText-Semibold;
                font-size: 14px;
                color: #168cd8;
                line-height: 20px;
                position: relative;
                display: flex;
                align-items: center;
            }
        }
        .list-body {
            padding-top: 2px;
            background-color: #e7ebf3;
            .empty {
                height: 468px;
                background: #fff;
                text-align: center;
                img {
                    width: 200px;
                    height: 150px;
                    margin-bottom: 32px;
                }
                p {
                    font-size: 28px;
                    color: rgba(50, 60, 80, 0.6);
                    line-height: 36px;
                }
            }
        }
    }
</style>
